<template>
  <form-select
      v-model="selectedIds"
      :p-currencies="pCurrencies"
      :p-language="pLanguage"
      :p-dictionary="pDictionary"
      :p-urls="pUrls"
      :p-error-list="pErrorList"
      :p-src="pSrc"
      :p-src-id="pSrcId"
      :p-ref-list="userRefList"
      :p-label-visible="false"
      :p-error-key="pInputPrefix + 'id'"
      :p-input-name="pInputPrefix + 'id'"
      p-style-class="btn-group-sm"
      :p-style-class-form-group="false"
      p-dictionary-key-select="dictionary.project.template.role.assignment.rule.default"
      :p-select-id-prefix="pClassPrefix + 'id'"
      p-select-container="#bsProjectTemplateSaveFormDialog"></form-select>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import FormSelect from "@/components/ui/FormSelect";
import refHelpers from "@/helpers/ref-helpers";

export default {
  name: "ProjectTemplateSaveFormTaskRuleRoleAssignmentUser",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  components: {
    FormSelect
  },
  props: {
    value: Object,
    pUserRefList: Array,
    pInputPrefix: String,
    pClassPrefix: String
  },
  data: function () {
    return {
      selectedIds: refHelpers.getId(this.value, null)
    }
  },
  methods: {

  },
  computed: {
    userRefList: function() {
      let userRefList = [];
      userRefList.push({id: -1, name: this.pDictionary['dictionary.project.template.role.assignment.rule.none'],
                         childDataRefs: [], names: { fr: null}});
      $.each( this.pUserRefList, function( key, value ) {
        userRefList.push(value);
      });
      return userRefList;
    }
  },
  watch: {
    value: function (newValue) {
      this.selectedIds = refHelpers.getRefId(newValue, null);
    },
    selectedIds: function () {
      let args = refHelpers.findRefById(this.pUserRefList, this.selectedIds, null);
      this.$emit('input', args)
    }
  },
  mounted: function () {

  }
}
</script>

<style scoped>

</style>